import { render, staticRenderFns } from "./CampaignRuleSetModal.vue?vue&type=template&id=05681c7a&scoped=true&"
import script from "./CampaignRuleSetModal.vue?vue&type=script&lang=js&"
export * from "./CampaignRuleSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05681c7a",
  null
  
)

export default component.exports